
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/boka-tid",
      function () {
        return require("private-next-pages/boka-tid/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/boka-tid"])
      });
    }
  